export default __webpack_public_path__ + "895824e4d2f707cc7dffe2336330915a.png";